import style from './scss/style.scss'
import AOS from 'aos'
import 'jquery-match-height'

var fixCoverHeight = function() {
  var newHeight = 20 + Math.max($('#nav-drawer').height(), $('#nav-main').height());
  $('._cover').css('padding-top', newHeight + 'px');
}

$(window).resize(fixCoverHeight);

$(function () {
  $('._card ._match-height').matchHeight({
    byRow: true,
    property: 'height',
    target: null,
    remove: false
  })
  $('.kalender-day').matchHeight({
    byRow: false,
    property: 'height',
    target: null,
    remove: false
  })
  AOS.init({
    offset: 0
  })
  var header = document.getElementById('nav-main')
  var sticky = header.offsetTop + 280
  window.onscroll = function () {
    if (window.pageYOffset > sticky) {
      header.classList.add('sticky')
    } else {
      header.classList.remove('sticky')
    }
  }
  fixCoverHeight();
})